// Mesma regra aplicada no backend (appointments-backend/src/utils/passwordPolicy.js)
// e no app autenticado (appointments-frontend/src/utils/passwordPolicy.js) —
// mantenha as três em sincronia se a política mudar.
export const PASSWORD_REQUIREMENTS_MESSAGE =
  'A senha deve ter entre 8 e 16 caracteres, com pelo menos 1 letra, 1 número e 1 caractere especial'

export const PASSWORD_RULES = [
  { key: 'length', label: 'Entre 8 e 16 caracteres', test: (pw) => pw.length >= 8 && pw.length <= 16 },
  { key: 'letter', label: 'Pelo menos 1 letra', test: (pw) => /[A-Za-z]/.test(pw) },
  { key: 'number', label: 'Pelo menos 1 número', test: (pw) => /[0-9]/.test(pw) },
  { key: 'special', label: 'Pelo menos 1 caractere especial', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
]

export function isPasswordValid(password) {
  const pw = password || ''
  return PASSWORD_RULES.every((rule) => rule.test(pw))
}
